import { BasicAPI } from "@wiggot/core-apis/src/apis/config/api/basicApi"

class PropertyBasicAPI extends BasicAPI {
  constructor() {
    super({ domain: process.env.LISTINGS_URL_API ?? '' })
  }
}

export const propertyBasicAPI = new PropertyBasicAPI()
